import type {
  Audience,
  BusinessType,
  Goal,
  Platform,
  Tone,
} from '@content-planner/shared';
import type { Choice } from './ChoiceGroup.js';

export const businessTypeChoices: ReadonlyArray<Choice<BusinessType>> = [
  { value: 'service_provider', label: 'Service provider', hint: 'Coach, consultant, agency, freelancer.' },
  { value: 'local_business', label: 'Local business', hint: 'Brick-and-mortar or service-area.' },
  { value: 'b2b', label: 'B2B', hint: 'Sell to other businesses.' },
  { value: 'ecommerce', label: 'Ecommerce', hint: 'Online store, physical or digital goods.' },
  { value: 'nonprofit', label: 'Nonprofit', hint: 'Cause, community, or mission-driven.' },
  { value: 'other', label: 'Other', hint: 'Tell us in your own words.' },
];

export const audienceChoices: ReadonlyArray<Choice<Audience>> = [
  { value: 'business_owners', label: 'Business owners' },
  { value: 'consumers', label: 'Consumers' },
  { value: 'specific_professionals', label: 'Specific professionals' },
  { value: 'local_community', label: 'Local community' },
  { value: 'other', label: 'Other' },
];

export const goalChoices: ReadonlyArray<Choice<Goal>> = [
  { value: 'brand_awareness', label: 'Brand awareness' },
  { value: 'lead_gen', label: 'Generate leads' },
  { value: 'top_of_mind', label: 'Stay top of mind' },
  { value: 'thought_leadership', label: 'Thought leadership' },
  { value: 'promote_offer', label: 'Promote an offer' },
  { value: 'all_of_above', label: 'A mix of the above' },
];

export const platformChoices: ReadonlyArray<Choice<Platform>> = [
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'facebook', label: 'Facebook' },
];

export const toneChoices: ReadonlyArray<Choice<Tone>> = [
  { value: 'friendly', label: 'Friendly' },
  { value: 'professional', label: 'Professional' },
  { value: 'warm', label: 'Warm' },
  { value: 'bold', label: 'Bold' },
  { value: 'educational', label: 'Educational' },
];

export function nextTwelveMonths(now: Date = new Date()): string[] {
  const formatter = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });
  const out: string[] = [];
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() + i, 1);
    out.push(formatter.format(d));
  }
  return out;
}
